(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["altapets-product-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('altapets-product-upsell')) {
    customElements.define(
      'altapets-product-upsell',
      class AltaPetsProductUpsell extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-upsell-dialog]');
          this.openButton = this.querySelector('[data-upsell-open]');
          this.closeButton = this.querySelector('[data-upsell-close]');
          this.form = this.querySelector('form');
          this.productForm = this.querySelector('product-form-component');
          this.variantSelect = this.querySelector('[data-upsell-variant-select]');
          this.variantInput = this.querySelector('[data-upsell-variant-input]');
          this.planSelect = this.querySelector('[data-upsell-plan-select]');
          this.planInput = this.querySelector('[data-upsell-plan-input]');
          this.planField = this.querySelector('[data-upsell-plan-field]');
          this.purchaseTypes = [...this.querySelectorAll('[data-upsell-purchase-type]')];
          this.quantityInput = this.querySelector('[data-upsell-quantity]');
          this.submitButton = this.querySelector('[data-upsell-submit]');
          this.submitLabel = this.querySelector('[data-upsell-submit-label]');
          this.modalPrice = this.querySelector('[data-upsell-modal-price]');
          this.modalImage = this.querySelector('[data-upsell-modal-image]');
          this.status = this.querySelector('[data-upsell-status]');

          const dataElement = this.querySelector('[data-upsell-product-data]');
          if (!this.dialog || !this.openButton || !dataElement) return;

          try {
            this.productData = JSON.parse(dataElement.textContent);
          } catch (error) {
            console.error('[Altapets upsell] No se pudo leer la información del producto.', error);
            return;
          }

          this.moneyFormatter = new Intl.NumberFormat(this.productData.locale || document.documentElement.lang || 'es-MX', {
            style: 'currency',
            currency: this.productData.currency || 'MXN'
          });

          this.openButton.addEventListener('click', () => this.open());
          this.closeButton?.addEventListener('click', () => this.close());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });

          this.variantSelect?.addEventListener('change', () => this.update());
          this.planSelect?.addEventListener('change', () => this.update());
          this.purchaseTypes.forEach((input) => input.addEventListener('change', () => this.update()));

          this.querySelector('[data-upsell-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(-1));
          this.querySelector('[data-upsell-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(1));

          this.form?.addEventListener('submit', () => this.setLoading(true));
          this.productForm?.addEventListener('shopify:cart:lines-update', (event) => this.handleCartUpdate(event));

          this.update();
        }

        open() {
          if (!this.dialog.open) this.dialog.showModal();
        }

        close() {
          if (this.dialog?.open) this.dialog.close();
          this.openButton?.focus({ preventScroll: true });
        }

        changeQuantity(amount) {
          if (!this.quantityInput) return;
          const minimum = Number(this.quantityInput.min) || 1;
          const current = Number(this.quantityInput.value) || minimum;
          this.quantityInput.value = String(Math.max(minimum, current + amount));
        }

        getSelectedVariant() {
          const id = this.variantSelect?.value || this.variantInput?.value;
          return this.productData?.variants?.[id] || null;
        }

        getPurchaseType() {
          return this.purchaseTypes.find((input) => input.checked)?.value || 'one_time';
        }

        selectFirstAvailablePlan(variant) {
          if (!this.planSelect) return '';

          const availablePlanIds = new Set(Object.keys(variant?.plans || {}));
          let selectedIsAvailable = false;
          let firstAvailable = '';

          [...this.planSelect.options].forEach((option) => {
            const available = availablePlanIds.has(option.value);
            option.disabled = !available;
            if (available && !firstAvailable) firstAvailable = option.value;
            if (available && option.value === this.planSelect.value) selectedIsAvailable = true;
          });

          if (!selectedIsAvailable) this.planSelect.value = firstAvailable;
          return this.planSelect.value;
        }

        update() {
          const variant = this.getSelectedVariant();
          if (!variant || !this.variantInput) return;

          const variantId = this.variantSelect?.value || this.variantInput.value;
          this.variantInput.value = variantId;

          if (this.modalImage && variant.image) this.modalImage.src = variant.image;

          const purchaseType = this.getPurchaseType();
          const subscriptionSelected = purchaseType === 'subscription';
          const planId = this.selectFirstAvailablePlan(variant);
          const subscriptionAvailable = Boolean(planId);

          const subscriptionRadio = this.purchaseTypes.find((input) => input.value === 'subscription');
          if (subscriptionRadio) subscriptionRadio.disabled = !subscriptionAvailable;

          if (subscriptionSelected && !subscriptionAvailable) {
            const oneTimeRadio = this.purchaseTypes.find((input) => input.value === 'one_time');
            if (oneTimeRadio) oneTimeRadio.checked = true;
          }

          const finalPurchaseType = this.getPurchaseType();
          const usePlan = finalPurchaseType === 'subscription' && subscriptionAvailable;

          if (this.planField) this.planField.hidden = !usePlan;
          if (this.planInput) {
            this.planInput.disabled = !usePlan;
            this.planInput.value = usePlan ? planId : '';
          }

          const price = usePlan ? variant.plans[planId] : variant.price;
          const formattedPrice = this.formatMoney(price);

          if (this.modalPrice) this.modalPrice.textContent = formattedPrice;

          if (this.submitButton) {
            this.submitButton.disabled = !variant.available || (finalPurchaseType === 'subscription' && !subscriptionAvailable);
          }

          if (this.status) this.status.textContent = variant.available ? '' : 'Esta variante está agotada.';
        }

        formatMoney(cents) {
          return this.moneyFormatter.format((Number(cents) || 0) / 100);
        }

        setLoading(loading) {
          if (!this.submitButton || !this.submitLabel) return;
          this.submitButton.disabled = loading;
          this.submitButton.setAttribute('aria-busy', loading ? 'true' : 'false');
          this.submitLabel.textContent = loading ? 'Agregando…' : this.dataset.submitLabel || 'Agregar al carrito';
          if (loading && this.status) this.status.textContent = '';
        }

        handleCartUpdate(event) {
          if (!event.promise) return;

          event.promise
            .then(({ detail }) => {
              this.setLoading(false);

              if (detail?.didError) {
                if (this.status) this.status.textContent = 'No se pudo agregar. Intenta nuevamente.';
                this.update();
                return;
              }

              if (this.status) this.status.textContent = 'Producto agregado al carrito.';

              window.setTimeout(() => {
                this.close();
                if (window.Shopify?.actions?.openCart) window.Shopify.actions.openCart();
              }, 350);
            })
            .catch(() => {
              this.setLoading(false);
              if (this.status) this.status.textContent = 'Ocurrió un error. Intenta nuevamente.';
              this.update();
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["altapets-product-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('altapets-product-videos')) {
    customElements.define(
      'altapets-product-videos',
      class AltaPetsProductVideos extends HTMLElement {
        connectedCallback() {
          this.cards = [...this.querySelectorAll('[data-video-card]')];
          this.previewVideos = this.cards.map((card) => card.querySelector('video')).filter(Boolean);
          this.viewer = this.querySelector('[data-video-viewer]');
          this.viewerMedia = this.querySelector('[data-viewer-media]');
          this.soundButton = this.querySelector('[data-viewer-sound]');
          this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.shouldLoop = this.dataset.loop === 'true';
          this.activeIndex = -1;

          this.handleClick = this.handleClick.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.addEventListener('click', this.handleClick);
          this.viewer?.addEventListener('click', this.handleClick);
          document.addEventListener('keydown', this.handleKeydown);

          this.previewVideos.forEach((video) => {
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
          });

          this.observePreviews();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.viewer?.removeEventListener('click', this.handleClick);
          document.removeEventListener('keydown', this.handleKeydown);
          this.observer?.disconnect();
          this.closeViewer(false);
          this.viewer?.remove();
        }

        observePreviews() {
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  const video = entry.target;

                  if (entry.isIntersecting && entry.intersectionRatio >= 0.35 && this.autoplay && this.viewer?.hidden) {
                    this.playPreview(video);
                  } else if (!entry.isIntersecting || entry.intersectionRatio < 0.2 || !this.viewer?.hidden) {
                    video.pause();
                  }
                });
              },
              { threshold: [0, 0.2, 0.35, 0.75] }
            );

            this.previewVideos.forEach((video) => this.observer.observe(video));
          } else if (this.autoplay) {
            this.previewVideos.forEach((video) => this.playPreview(video));
          }
        }

        handleClick(event) {
          const openButton = event.target.closest('[data-video-open]');
          if (openButton) {
            const card = openButton.closest('[data-video-card]');
            const index = this.cards.indexOf(card);
            if (index >= 0) this.openViewer(index);
            return;
          }

          if (event.target.closest('[data-viewer-close]')) {
            this.closeViewer();
            return;
          }

          if (event.target.closest('[data-viewer-sound]')) {
            this.toggleSound();
            return;
          }

          if (event.target.closest('[data-viewer-fullscreen]')) {
            this.openFullscreen();
            return;
          }

          if (event.target.closest('[data-viewer-previous]')) {
            this.showVideo(this.activeIndex - 1);
            return;
          }

          if (event.target.closest('[data-viewer-next]')) {
            this.showVideo(this.activeIndex + 1);
          }
        }

        handleKeydown(event) {
          if (this.viewer?.hidden) return;

          if (event.key === 'Escape') this.closeViewer();
          if (event.key === 'ArrowUp') this.showVideo(this.activeIndex - 1);
          if (event.key === 'ArrowDown') this.showVideo(this.activeIndex + 1);
        }

        openViewer(index) {
          this.moveViewerAbovePage();
          this.viewer.hidden = false;
          this.viewer.setAttribute('aria-hidden', 'false');
          this.previewVideos.forEach((video) => video.pause());
          this.showVideo(index);
          this.viewer.querySelector('[data-viewer-close]')?.focus({ preventScroll: true });
        }

        moveViewerAbovePage() {
          if (!this.viewer || this.viewer.parentElement === document.body) return;

          const blockStyles = window.getComputedStyle(this);
          [
            '--apv-viewer-desktop-width',
            '--apv-viewer-mobile-width',
            '--apv-viewer-border',
            '--apv-radius',
            '--apv-background'
          ].forEach((property) => {
            const value = blockStyles.getPropertyValue(property).trim();
            if (value) this.viewer.style.setProperty(property, value);
          });

          document.body.appendChild(this.viewer);
        }

        showVideo(index) {
          const total = this.cards.length;
          if (!total) return;

          this.activeIndex = (index + total) % total;
          const preview = this.previewVideos[this.activeIndex];
          if (!preview) return;

          this.player?.pause();
          const player = preview.cloneNode(true);
          player.className = 'altapets-product-videos__viewer-video';
          player.controls = false;
          player.autoplay = false;
          player.loop = this.shouldLoop;
          player.playsInline = true;
          player.defaultMuted = false;
          player.muted = false;
          player.volume = 1;

          this.viewerMedia.replaceChildren(player);
          this.player = player;
          this.updateSoundButton();

          const attempt = player.play();
          attempt?.catch(() => {
            player.muted = true;
            this.updateSoundButton();
            player.play().catch(() => {});
          });
        }

        closeViewer(resumePreviews = true) {
          if (!this.viewer) return;

          this.player?.pause();
          this.player = null;
          this.viewerMedia?.replaceChildren();
          this.viewer.hidden = true;
          this.viewer.setAttribute('aria-hidden', 'true');
          this.activeIndex = -1;

          if (resumePreviews && this.autoplay) {
            this.previewVideos.forEach((video) => {
              const rect = video.getBoundingClientRect();
              const visible = rect.bottom > 0 && rect.top < window.innerHeight;
              if (visible) this.playPreview(video);
            });
          }
        }

        toggleSound() {
          if (!this.player) return;
          this.player.muted = !this.player.muted;
          if (!this.player.muted) this.player.volume = 1;
          this.updateSoundButton();
        }

        updateSoundButton() {
          if (!this.player || !this.soundButton) return;
          const muted = this.player.muted;
          this.soundButton.classList.toggle('is-muted', muted);
          this.soundButton.setAttribute('aria-label', muted ? 'Activar sonido' : 'Silenciar video');
        }

        openFullscreen() {
          if (!this.player) return;

          if (this.player.requestFullscreen) {
            this.player.requestFullscreen();
          } else if (this.player.webkitEnterFullscreen) {
            this.player.webkitEnterFullscreen();
          } else if (this.viewer.requestFullscreen) {
            this.viewer.requestFullscreen();
          }
        }

        playPreview(video) {
          video.muted = true;
          video.play().catch(() => {});
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
